@for (item of charts; track item; let i = $index) {
  <div class="row chart-row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      @if (data.datasets[i].data.length) {
        <p-chart data-id="{{item.id}}" name="chart" #chart type="bar" [data]="data" [options]="options"></p-chart>
      }
    </div>
  </div>
}
